import { useState } from "react";
import { api } from "./api";

/** Internal entry point only: ?room=…&agentConnect=1. No normal workspace navigation. */
export function AgentConnection({
  boardId,
  name,
}: {
  boardId: string;
  name?: string;
}) {
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  async function connect() {
    setBusy(true);
    try {
      const config = await api(`/api/rooms/${boardId}/agent/connection`, {});
      const url = URL.createObjectURL(
        new Blob([JSON.stringify(config)], { type: "application/json" }),
      );
      const a = document.createElement("a");
      a.href = url;
      a.download = "calque-agent-session.json";
      a.click();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
      setMessage(
        "Connection downloaded. Move it to a private location and run chmod 600 before using it. It expires in one hour.",
      );
    } catch (error) {
      setMessage((error as Error).message);
    } finally {
      setBusy(false);
    }
  }
  return (
    <main
      style={{
        maxWidth: 620,
        margin: "80px auto",
        padding: 32,
        lineHeight: 1.6,
      }}
    >
      <h1>Connect an internal agent</h1>
      <p>
        <a href="/oauth/connections">Use OAuth: connect and manage access</a>
      </p>
      <p>
        Or use the one-hour local companion when your agent needs to read
        image files directly from this computer.
      </p>
      <p>
        <strong>{name ?? "Loading project…"}</strong>
      </p>
      <ul>
        <li>Read and edit this project using your current access.</li>
        <li>
          Connection expires after one hour. Signing out revokes it sooner.
        </li>
        <li>
          No access to unrelated projects, invitations or account settings.
        </li>
      </ul>
      <p>
        The downloaded file contains a private connection key. Keep it out of
        Git, chat and project sheets.
      </p>
      <button disabled={busy || !name} onClick={() => void connect()}>
        Download one-hour connection
      </button>
      <p role="status">{message}</p>
      <a href={`/?room=${encodeURIComponent(boardId)}`}>Return to project</a>
    </main>
  );
}
